import React from "react";

function LogistikConfirm({
  title,
  children,
  confirmLabel = "Ja, löschen",
  cancelLabel = "Nein, weiter",
  onConfirm,
  onCancel,
}) {
  return (
    <div className="logistik-confirm-overlay no-print" role="presentation">
      <div className="logistik-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="logistik-confirm-title">
        <h2 id="logistik-confirm-title">{title}</h2>
        <div className="logistik-confirm-copy">{children}</div>
        <div className="logistik-confirm-buttons">
          <button type="button" className="logistik-confirm-no" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className="logistik-confirm-yes" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LogistikConfirm;
